import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import Raven from 'raven-js';
import { useMemo } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UsageTracker from '../../../utils/UsageTracker';
import { usePlaylistSaveStatus } from '../../savedItems';
import { SavePlaylistsToggleIconMessage } from './SavePlaylistsToggleIcon';

const SavePlaylistButton = (_ref) => {
  let {
    playlistId,
    language = getLang(),
    showNotification = true,
    showTooltip = false,
    onClick,
    use = 'unstyled',
    onSuccess,
    render = content => /*#__PURE__*/_jsx(_Fragment, {
      children: content
    })
  } = _ref,
      buttonProps = _objectWithoutPropertiesLoose(_ref, ["playlistId", "language", "showNotification", "showTooltip", "onClick", "use", "onSuccess", "render"]);

  const {
    isSaved,
    isOwner,
    isLoading,
    togglePlaylistSaveStatus
  } = usePlaylistSaveStatus(playlistId, {
    showNotification,
    language
  });

  const handleOnClick = e => {
    if (isLoading) return;
    if (onClick) onClick(e);
    const trackingAction = isSaved ? 'remove-playlist' : 'save-playlist';
    UsageTracker.track('playlistInteraction', {
      action: trackingAction,
      isOwner,
      playlistId
    });
    togglePlaylistSaveStatus().then(onSuccess).catch(() => {
      Raven.captureMessage(`Achievements: error saving/archiving playlist`, {
        extra: {
          playlistId,
          language,
          isSaved,
          isOwner
        }
      });
    });
  };

  const tooltip = useMemo(() => {
    if (!showTooltip) return null;

    if (isOwner) {
      return I18n.text('learningCenter.savedItems.tooltips.archiveHover');
    }

    return null;
  }, [isOwner, showTooltip]);
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "right",
    title: tooltip,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
      disabled: isLoading,
      onClick: handleOnClick,
      use: use,
      children: render( /*#__PURE__*/_jsx(SavePlaylistsToggleIconMessage, {
        isOwner: isOwner,
        isSaved: isSaved
      }))
    }))
  });
};

export default SavePlaylistButton;